import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { APP_CONFIG, AppConfig } from '@core/config/app-config';
import { isPlatformBrowser } from '@angular/common';
import { Observable } from 'rxjs';
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
import { buildNewRelicConfig } from '@core/observability/newrelic/newrelic.config';
import { BROWSER_AGENT } from '@core/observability/newrelic/newrelic.tokens';

@Injectable({
  providedIn: 'root',
})
export class NewRelicService {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly appConfig: AppConfig = inject(APP_CONFIG);
  private readonly browserAgent = inject(BROWSER_AGENT);
  private newRelicAgentInstance: BrowserAgent | null = null;

  init(): Observable<void> {
    return new Observable(observer => {
      try {
        if (!isPlatformBrowser(this.platformId) || !this.appConfig.newRelic.enabled) {
          observer.complete();
          return;
        }

        const options = buildNewRelicConfig(this.appConfig);
        this.newRelicAgentInstance = new this.browserAgent(options);
        observer.complete();
      } catch (error) {
        observer.error(error);
      }
    });
  }
}
